//axios api
import api from "@/lib/Api";

export const getRefundRecord = async (selectedShop, startDate, endDate) => {
  try {
    const queryRoute = `/refund/getRefundRecord`;

    const reqBody = {
      selectedShop: selectedShop ? selectedShop : 0,
      startDate: startDate ? startDate : null,
      endDate: endDate ? endDate : null,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
